import z from "zod";

const formattingErrorTypeValues = [
  "INVALID_DATE_STRING",
  "INVALID_DATE",
  "INVALID_DATA_URL_FORMAT",
  "INVALID_ID",
  "INVALID_CONVERSATION_KEY",
  "FICTIONAL_PHONE_NUMBER_INDEX_OUT_OF_RANGE",
] as const;

const formattingErrorTypeSchema = z.enum(formattingErrorTypeValues);
const FormattingErrorType = formattingErrorTypeSchema.enum;
type FormattingErrorType = z.infer<typeof formattingErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type FormattingErrors =
  | {
      errorType: typeof FormattingErrorType.INVALID_DATE_STRING;
      data: {
        providedValue: string;
      };
    }
  | {
      errorType: typeof FormattingErrorType.FICTIONAL_PHONE_NUMBER_INDEX_OUT_OF_RANGE;
      data: {
        index: number;
        capacity: number;
      };
    }
  | {
      errorType: typeof FormattingErrorType.INVALID_DATE;
      data: {
        providedValue: string;
      };
    }
  | {
      errorType: typeof FormattingErrorType.INVALID_DATA_URL_FORMAT;
      data: undefined;
    }
  | {
      errorType: typeof FormattingErrorType.INVALID_ID;
      data: {
        id: string;
        expectedFormat: string;
      };
    }
  | {
      errorType: typeof FormattingErrorType.INVALID_CONVERSATION_KEY;
      data: {
        key: string;
      };
    };

export const formattingErrorDetails: Record<FormattingErrorType, ErrorDetails> = {
  [FormattingErrorType.INVALID_DATE_STRING]: {
    sentryDescription: "Formatting received an invalid date string",
  },
  [FormattingErrorType.FICTIONAL_PHONE_NUMBER_INDEX_OUT_OF_RANGE]: {
    sentryDescription: "A fictional phone number was requested beyond the generator's capacity",
  },
  [FormattingErrorType.INVALID_DATE]: {
    sentryDescription: "Formatting received an invalid date value",
  },
  [FormattingErrorType.INVALID_DATA_URL_FORMAT]: {
    sentryDescription: "Formatting encountered an invalid data URL format",
  },
  [FormattingErrorType.INVALID_ID]: {
    sentryDescription: "Unable to parse id",
  },
  [FormattingErrorType.INVALID_CONVERSATION_KEY]: {
    sentryDescription: "Unable to parse external conversation key",
  },
};
